import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppLayout } from "@/components/layouts/AppLayout";
import LoginPage from "@/pages/LoginPage";
import BrandsPage from "@/pages/BrandsPage";
import CompaniesPage from "@/pages/CompaniesPage";
import RolePermissionsPage from "@/pages/RolePermissionsPage";
import ProgramsPage from "@/pages/ProgramsPage";
import AccountsPage from "@/pages/AccountsPage";
import CustomAddressesPage from "@/pages/CustomAddressesPage";
import OrderAnalyticsPage from "@/pages/OrderAnalyticsPage";
import SmsBillingPage from "@/pages/SmsBillingPage";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

export const router = createBrowserRouter(
  [
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="/companies" replace />,
        },
        {
          path: "companies",
          element: <CompaniesPage />,
        },
        {
          path: "order-analytics",
          element: <OrderAnalyticsPage />,
        },
        {
          path: "sms-billing",
          element: <SmsBillingPage />,
        },
        {
          path: "brands",
          element: <BrandsPage />,
        },
        {
          path: "role-permissions",
          element: <RolePermissionsPage />,
        },
        {
          path: "programs",
          element: <ProgramsPage />,
        },
        {
          path: "accounts",
          element: <AccountsPage />,
        },
        {
          path: "custom-addresses",
          element: <CustomAddressesPage />,
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
);
